import { Router } from '@angular/router';
import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ProductService } from '../services/product.service';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { NotificationService } from '../services/notification.service';
import { RestApiService } from '../services/restapi.service';
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from '../services/order.service';
import { ConfigService } from '../services/config.service';
import * as moment from 'moment';
import { SideNavBarService } from '../services/sidenavbar.service';
import { Cart1Service } from '../services/cart1.service';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { UtilityService } from '../services/utility.service';
import { PersistentService } from '../services/persistent.service';
import { AccountService } from '../services/account.service';
import { AutoshipConfigurationService } from '../services/autoshipConfiguration.service';
import { CompanyService } from '../services/company.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginDialogComponentComponent } from '../login-dialog-component/login-dialog-component.component';
import { FreeEnrollmentItemID, MARKETPLACESTORE, REWARDSTORE } from 'src/app/constant';

@Component({
    selector: 'app-sidebar-summary-cart',
    templateUrl: './sidebar-summary-cart.component.html',
    styleUrls: ['./sidebar-summary-cart.component.scss']
})
export class SideBarSummaryCartComponent implements OnInit {
    public commonData: any;
    public AutoshipMinDate: Date;
    public AutoshipMaxDate: Date;
    shouldRun: boolean = true;
    limit: 3;
    isShow: boolean;
    lastQuantity: 0;
    selectedfrequencyTypeID: 0;
    autoshipConfiguration: any = {
        setting: {
            allowEdit: true
        }
    };
    userService: UserServiceModal;
    currentState: any;
    checkoutVal: any;
    FreeEnrollmentItemID: any = FreeEnrollmentItemID;
    autoshipDate: any;

    constructor(
        public configService: ConfigService,
        public orderService: OrderService,
        public user: UserService,
        public notificationService: NotificationService,
        public apiService: RestApiService,
        public translate: TranslateService,
        public sideNavBarService: SideNavBarService,
        public cart1Service: Cart1Service,
        public itemsService: ProductService,
        public location: Location,
        public router: Router,
        public utilityService: UtilityService,
        public persistentService: PersistentService,
        public accountService: AccountService,
        public autoshipConfigurationService: AutoshipConfigurationService,
        public companyService: CompanyService,
        public dialog: MatDialog,
        private cdr: ChangeDetectorRef
    ) {
        this.autoshipConfigurationService.autoshipDate = new Date(autoshipConfigurationService.autoshipDate);
        this.userService = user.userServiceModal;
        // Remove FrequencyTypes-dependent code from constructor
        this.commonData = undefined;
    }
    @Input() events: Observable<void>;

    ngOnInit() {
        this.commonData = this.configService.getConfig();
        if (this.commonData && this.commonData.FrequencyTypes && this.commonData.FrequencyTypes.length > 0) {
            setTimeout(() => {
                this.selectedfrequencyTypeID = this.persistentService.retailData.Autoship.FrequencyTypeID = this.commonData.FrequencyTypes[0].ID;
                this.cdr.detectChanges();
            });
        } else {
            // handle missing config gracefully, maybe set a default or show an error
        }
        this.currentState = this.location.path();
        this.AutoshipMinDate = moment().add(this.configService.localSettings.Autoship.AutoshipMinDate, 'days').toDate();
        this.AutoshipMaxDate = moment().add(this.configService.localSettings.Autoship.AutoshipMaxDate, 'days').toDate();

    }

    /**
     * Check if autoship panel should be open by default
     * Returns true when there are ONLY subscription items (no regular order items or packs)
     */
    shouldAutoshipPanelBeOpen(): boolean {
        return this.itemsService.selectedAutoOrderItems?.length > 0 &&
            (!this.itemsService.selectedOrderItems || this.itemsService.selectedOrderItems.length === 0) &&
            (!this.itemsService.selectedPacks || this.itemsService.selectedPacks.length === 0);
    }

    myFilter = (d: Date): boolean => {
        const date = d?.getDate();
        return (
            date !== 30 &&
            date !== 31
        );
    };

    showTaxMessage() {
        return !(this.location.path().toLowerCase() == '/join') && !(this.location.path().toLowerCase() == '/checkout') &&
            (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedAutoOrderItems.length > 0 ||
                this.itemsService.selectedPacks.length > 0);
    }

    getPacksQuanity() {
        var quantity = 0;
        _.each(this.itemsService.selectedPacks, function (item) {
            quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
        });
        return quantity;
    }

    getOrderQuanity() {
        let quantity = 0;
        _.each(this.itemsService.selectedOrderItems, (item) => {
            if (!item.UsePoints) {
                quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
            }
            if (item.UsePoints) {
                quantity += (item.rewardQuantity ? parseInt(item.rewardQuantity, 10) : 0);
            }
        });
        return quantity;
    }

    getAutoOrderQuanity() {
        let quantity = 0;
        _.each(this.itemsService.selectedAutoOrderItems, (item) => {
            quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
        });
        return quantity;
    }

    removePromo(code) {
        this.userService.couponInfo.RewardsForUse = _.reject(this.userService.couponInfo.RewardsForUse, (e) => {
            return e.Code === code;
        });
        this.userService.couponInfo.promoCode = '';
        this.userService.couponInfo.promoCodeValid = false;
        this.userService.couponInfo.IsAppliedcode = false;
        this.userService.couponInfo.Allcoupons.splice(this.userService.couponInfo.Allcoupons.indexOf(code), 1);
        this.orderService.calculateOrder();
    }
    getCustomerTypeName(): any {
        const custmerType = _.find(this.configService.commonSettings.CustomerTypes, (item) => {
            return (item.ID == this.userService.customerTypeID);
        });
        if (custmerType) {
            return { type: 'Guest' };
        }
    }

    dateFilter(date) {
        let disableDates = [];
        if (disableDates.length === 0) {
            disableDates = [];
        }
        return disableDates.indexOf(moment(date).format('DD MMMM YYYY')) === -1;
    }

    submitApplication() {
        document.querySelectorAll<HTMLElement>('#place-order-btn')[0].click();
    }

    checkitem() {
        if (this.utilityService.getAutoshipEditFlag()) {
            return true;
        }
        return (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedAutoOrderItems.length > 0);
    }

    navigateToNextStep() {
        this.sideNavBarService.triggerOpen();
        if (this.currentState.toLowerCase() == '/checkout' && (Object.keys(this.userService.customerData).length)
            && (this.userService.customerData.CustomerId || this.userService.customerData.PrimaryAddress.Region) && this.checkitem()
            && this.user.checkIfUserAuthenticatedOrNot()) {
            this.submitApplication();
        } else if (this.currentState.toLowerCase() != '/checkout' && (Object.keys(this.userService.customerData).length)
            && (this.userService.customerData.CustomerId || this.userService.customerData.PrimaryAddress.Region)
            && this.checkitem() && this.user.checkIfUserAuthenticatedOrNot()) {
            this.router.navigate(['/checkout']);
        } else if (this.checkitem() && ((Object.keys(this.userService.customerData).length === 0 && !this.userService.customerData.CustomerId)
            || !this.user.checkIfUserAuthenticatedOrNot())) {
            if (this.currentState.toLowerCase() == '/checkout') {
                this.accountService.logout();
            }
            this.loginDialog();
        } else if (this.currentState.toLowerCase() != '/products/all') {
            this.router.navigate(['/products/all']);
        } else if (!this.checkitem()) {
            this.notificationService.error('error_', 'error_no_item_selected');
        }
    }

    isEditingAutoship(): boolean {
        return this.utilityService.getAutoshipEditFlag();
    }

    navigateToApplication() {
        const application = (this.configService.localSettings.Global.ConfigurableCheckout && this.userService.customerData.CustomerId) ? '/checkout' : '/join';
        this.sideNavBarService.triggerOpen();
        if ((Object.keys(this.userService.customerData).length || this.userService.guestUserData.Email) &&
            (this.userService.customerData.CustomerId || this.userService.customerData.PrimaryAddress.Region || this.userService.guestUserData.Email)
            && this.checkitem() && this.user.checkIfUserAuthenticatedOrNot()) {
            this.router.navigate([application]);
        } else if (this.checkitem() && ((Object.keys(this.userService.customerData).length === 0
            && !this.userService.customerData.CustomerId) || !this.user.checkIfUserAuthenticatedOrNot())) {
            if (this.location.path().toLowerCase() == '/checkout' || this.userService.guestUserLogin) {
                this.accountService.logout();
            }
            this.loginDialog();
        } else if (this.location.path().toLowerCase() != '/products/all') {
            this.router.navigate(['/products/all']);
        } else if (!this.checkitem()) {
            this.notificationService.error('error_', 'error_no_item_selected');
        }
    }

    showLogincheckoutBtn() {
        const path = this.location.path().toLowerCase();
        return path !== '/checkout' && path !== '/join';
    }

    useCoupons() {
        return (
            this.userService.couponInfo.OrderAllowCoupons &&
            this.userService.couponInfo.availableRewards &&
            this.userService.couponInfo.availableRewards.length
        );
    }

    checkRewardStatus(reward) {
        const isInUse = this.userService.couponInfo.RewardsForUse.some((currentReward) => {
            return currentReward.Code === reward.Code;
        });
        return isInUse;
    }

    toggleCoupon(coupon) {
        const applied = this.userService.couponInfo.RewardsForUse.some((reward) => {
            return reward.Code === coupon.Code;
        });

        if (applied && this.userService.DynamicCouponCode.promoCode != coupon.Code) {
            this.removePromo(coupon.Code);
        } else {
            this.userService.couponInfo.RewardsForUse.push(coupon);
            if (this.userService.couponInfo.RewardsForUse.length) {
                _.each(this.userService.couponInfo.RewardsForUse, (reward) => {
                    const IsCouponAvailable = this.userService.couponInfo.Allcoupons.some((coupon) => {
                        return reward.Code === coupon;
                    });
                    if (!IsCouponAvailable) {
                        this.userService.couponInfo.Allcoupons.push(reward.Code);
                    }

                });
            }
            this.orderService.calculateOrder();
        }
    }


    goToSignUp() {
        this.sideNavBarService.triggerOpen();
        // Allow signup with either order items or autoship items
        if (this.itemsService.selectedOrderItems.length == 0 && this.itemsService.selectedAutoOrderItems.length == 0) {
            const msg = 'unified_order_item_required';
            this.notificationService.error('error_', this.translate.instant(msg));
            return;
        }
        //<!-- ************** uncomment when real peoducts come or in prod mode ***************** -->
        // if (this.itemsService.selectedAutoOrderItems == 0 && this.configService.localSettings.Global.AutoshipItemRequired[this.userService.customerTypeID]) {
        //     const AutoshipMsg = 'unified_auto_order_item_required';
        //     this.notificationService.error('error_', this.translate.instant(AutoshipMsg));
        //     return;
        // }
        this.router.navigate(['/signup']);
    }
    loginDialog() {
        // Clear guest session data before opening login dialog to prevent stale data issues
        this.user.clearCustomerData();
        this.userService.guestUserData = {};

        const dialogRef = this.dialog.open(LoginDialogComponentComponent, {
            width: "600px",
            autoFocus: false
        });

        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    showNewCustomerBtn() {
        if (this.user.checkIfUserAuthenticatedOrNot()) {
            return false;
        } else if (this.location.path().toLowerCase() == '/signup' || this.location.path().toLowerCase() == '/join') {
            return false;
        } else {
            return true;
        }

    }

    isLoggedIn() {
        if ((Object.keys(this.userService.customerData).length) && (this.userService.customerData.CustomerId) && this.user.checkIfUserAuthenticatedOrNot()) {
            return true;
        } else {
            return false;
        }
    }

    isAutoshipChanged() {
        if (!moment(this.autoshipConfigurationService.autoshipDate).isSame(this.persistentService.retailData.autoshipDate, 'day')) {
            return true;
        }
        if (this.persistentService.retailData.Autoship && this.commonData.FrequencyTypes[0].ID != this.persistentService.retailData.Autoship.FrequencyTypeID) {
            return true;
        }
        if (this.userService.isAddressChanged || this.userService.isPaymentChanged || this.userService.isShipMethodChanged) {
            return true;
        }

        if (this.utilityService.getAutoshipEditFlag()) {
            if (this.persistentService.retailData.isChanged) {
                if (_.isEqual(this.persistentService.retailData.editAutoshipItems, this.itemsService.selectedAutoOrderItems) &&
                    this.itemsService.selectedOrderItems.length == 0) {
                    return false;
                }
                return true;
            }
            return false;
        }
        return true;
    }

    cancelAutoship() {
        this.router.navigate(['/manageautoship']);
        this.sideNavBarService.triggerOpen();
        this.notificationService.success('Success', this.translate.instant('autoship_cancel'));
    }

    deleteAutoship(autoShipId?: number) {

        this.apiService.deleteAutoship(autoShipId).subscribe((result) => {
            if (result && Number(result.Status) === 1) {
                this.notificationService.error('error_', this.translate.instant('some_error_occur_try_again'));
            } else {
                this.notificationService.success('Success', this.translate.instant('successfully_deleted'));
            }
        }, (error) => {
        }, () => {
        });
    }

    setFrequency() {
        this.commonData.FrequencyTypes.some((freq) => {
            if (freq.ID == this.persistentService.retailData.Autoship.FrequencyTypeID) {
                this.persistentService.retailData.Autoship.FrequencyTypeID = freq.ID;
                this.persistentService.retailData.Autoship.FrequencyTypeID = freq.ID;
                this.persistentService.retailData.Autoship.FrequencyTypeDescription = freq.Description;
                this.persistentService.retailData.isChanged = true;
                return;
            }
        });
    }

    saveEditAutoship() {
        this.sideNavBarService.triggerOpen();
        this.router.navigate(['/manageautoship']);
    }

    navigateToAutoshipEdit() {
        // Re-read from localStorage to ensure we have the latest data
        this.persistentService.getRetailData();
        // Get autoship ID from either CurrentSelectedAutoOrder or AddMoreItemInAutoshipData
        const autoshipId = this.persistentService.retailData.CurrentSelectedAutoOrder ||
                           this.persistentService.retailData.AddMoreItemInAutoshipData?.id;

        // Set flags for checkout to update existing autoship (not create new)
        this.persistentService.retailData.isNewAutoship = false;
        this.persistentService.retailData.CurrentSelectedAutoOrder = autoshipId;
        this.persistentService.setRetailData();

        this.sideNavBarService.triggerOpen();
        // Navigate to checkout - it will update the existing autoship
        this.router.navigate(['/checkout']);
    }

    cancelAutoshipEdit() {
        this.sideNavBarService.triggerOpen();
        this.persistentService.retailData.AddMoreItemInAutoshipFlag = false;
        this.utilityService.setAutoshipEditFlag(false);
        this.persistentService.retailData.CurrentSelectedAutoOrder = 0;
        this.persistentService.retailData.AddMoreItemInAutoshipData = {};
        this.cart1Service.clearCart();
        this.router.navigate(['/shop']);

    }

    getAutoshipNumber() {
        return this.translate.instant('_invoice_autoorder') +
            this.persistentService.retailData.CurrentSelectedAutoOrder;
    }

    canCheckOut() {
        if (this.userService.customerData.CustomerId) {
            return true; // this.rewardPointsService.validatePointBalance();
        }
        return true;
    }

    getItems(type: string) {
        return this.itemsService[type == 'pack' ? 'selectedPacks' : (type == 'autoship' ? 'selectedAutoOrderItems' : 'selectedOrderItems')];
    }

    getTotalRV() {
        let totalRV = 0;
        
        // Add pack RV
        if (this.itemsService.selectedPacks.length > 0) {
            totalRV += this.orderService.packBusinessVolume || 0;
        }
        
        // Add order RV
        if (this.itemsService.selectedOrderItems.length > 0) {
            totalRV += this.orderService.orderBusinessVolume || 0;
        }
        
        // Add autoship RV
        if (this.itemsService.selectedAutoOrderItems.length > 0) {
            totalRV += this.orderService.autoorderBusinessVolume || 0;
        }
        
        return totalRV;
    }

    // Manual calculation for debugging
    getManualTotalRV() {
        let totalRV = 0;
        
        // Calculate pack RV manually
        this.itemsService.selectedPacks.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        // Calculate order RV manually
        this.itemsService.selectedOrderItems.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        // Calculate autoship RV manually
        this.itemsService.selectedAutoOrderItems.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        return totalRV;
    }

    getManualPackAndOrderRV() {
        let totalRV = 0;
        
        // Calculate pack RV manually
        this.itemsService.selectedPacks.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        // Calculate order RV manually
        this.itemsService.selectedOrderItems.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        return totalRV;
    }

    getManualAutoshipRV() {
        let totalRV = 0;
        
        // Calculate autoship RV manually
        this.itemsService.selectedAutoOrderItems.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        return totalRV;
    }

    getManualPackRV() {
        let totalRV = 0;
        
        // Calculate pack RV manually
        this.itemsService.selectedPacks.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        return totalRV;
    }

    getManualOrderRV() {
        let totalRV = 0;
        
        // Calculate order RV manually
        this.itemsService.selectedOrderItems.forEach(item => {
            totalRV += (item.Quantity || 1) * (item.RV || 0);
        });
        
        return totalRV;
    }

    getTotalQuantity() {
        let totalQuantity = 0;
        
        // Add pack quantity
        totalQuantity += this.getPacksQuanity();
        
        // Add order quantity
        totalQuantity += this.getOrderQuanity();
        
        // Add autoship quantity
        totalQuantity += this.getAutoOrderQuanity();
        
        return totalQuantity;
    }

    getGrandTotal() {
        if (!this.isLoggedIn()) {
            return this.getGrandTotalForGuest();
        }
        
        let grandTotal = 0;
        
        // Only add order total if there are actual order items
        if ((this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedPacks.length > 0) && 
            this.orderService.calculateOrderResponse && 
            this.orderService.calculateOrderResponse.Total) {
            grandTotal += this.orderService.calculateOrderResponse.Total;
        }
        
        // Add autoship total if there are autoship items
        if (this.itemsService.selectedAutoOrderItems.length > 0 && 
            this.orderService.calculateAutoOrderResponse && 
            this.orderService.calculateAutoOrderResponse.Total) {
            grandTotal += this.orderService.calculateAutoOrderResponse.Total;
        }
        
        return grandTotal;
    }

    // Calculate grand total using original product prices for guest users
    getGrandTotalForGuest() {
        let grandTotal = 0;
        
        // Calculate order items total
        this.itemsService.selectedOrderItems.forEach(item => {
            grandTotal += (item.Price || 0) * (item.Quantity || 1);
        });
        
        // Calculate pack items total
        this.itemsService.selectedPacks.forEach(item => {
            grandTotal += (item.Price || 0) * (item.Quantity || 1);
        });
        
        // Calculate autoship items total
        this.itemsService.selectedAutoOrderItems.forEach(item => {
            grandTotal += (item.Price || 0) * (item.Quantity || 1);
        });
        
        return grandTotal;
    }

    // Get subtotal for guest users
    getSubtotalForGuest() {
        let subtotal = 0;
        
        // Calculate order items subtotal
        this.itemsService.selectedOrderItems.forEach(item => {
            subtotal += (item.Price || 0) * (item.Quantity || 1);
        });
        
        // Calculate pack items subtotal
        this.itemsService.selectedPacks.forEach(item => {
            subtotal += (item.Price || 0) * (item.Quantity || 1);
        });
        
        return subtotal;
    }

    // Get autoship subtotal for guest users
    getAutoshipSubtotalForGuest() {
        let subtotal = 0;
        
        // Calculate autoship items subtotal
        this.itemsService.selectedAutoOrderItems.forEach(item => {
            subtotal += (item.Price || 0) * (item.Quantity || 1);
        });
        
        return subtotal;
    }

    // Get pack total for guest users
    getPackTotalForGuest() {
        let total = 0;
        
        this.itemsService.selectedPacks.forEach(item => {
            total += (item.Price || 0) * (item.Quantity || 1);
        });
        
        return total;
    }

    // Get order total for guest users
    getOrderTotalForGuest() {
        let total = 0;
        
        this.itemsService.selectedOrderItems.forEach(item => {
            total += (item.Price || 0) * (item.Quantity || 1);
        });
        
        return total;
    }


    getImage(item) {
        return (item.OptionsImage && item.ImageUrl.substr(0, item.ImageUrl.lastIndexOf('/'))
            .concat(item.OptionsImage)) || item.ImageUrl;
    }

    view() {
        this.isShow = !this.isShow;
    }

    getQuantityModel(type, item): any {
        return this.cart1Service[type == 'pack' ? 'packQuantity' : (type == 'autoship' ? 'autoshipQuantity' : ((item && item.UsePoints) ? 'orderRewardQuantity' : 'orderQuantity'))];
    }

    increaseQuantiy(type, item) {
        this.cart1Service.increaseQuantiy(item, type == 'autoship', type == 'pack');
        this.updateQuantity(type, item, undefined);
    }

    decreaseQuantiy(type, item) {
        this.cart1Service.decreaseQuantiy(item, type == 'autoship', type == 'pack');
        this.updateQuantity(type, item, undefined);
    }

    removeFromCart(type, item) {
        this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true);
        this.updateQuantity(type, item, undefined);
    }

    updateQuantity(type, item, newValue) {
        if (newValue !== undefined) {
            // Handle ngModelChange event
            const quantityModel = this.getQuantityModel(type, item);
            if (quantityModel && item.ItemID) {
                quantityModel[item.ItemID] = newValue;
            }
        }
    }

    closeCart() {
        let newUrl: any;
        if (this.itemsService.selectedAutoOrderItems.length === 0 && this.itemsService.selectedOrderItems.length === 0) {
            // const subdomain = getSubdomain(window.location.host);
            // if (subdomain) {
            //     newUrl = window.location.href.replace(subdomain, this.userService.WebAlias);
            // }
            // if (this.location.path().toLowerCase().indexOf('product') > -1) {
            //     this.router.navigate(['/products/all']);
            // }
            // else if (this.location.path().toLowerCase() === '/join') {
            //     this.router.navigate(['/join']);
            // }
            if ([1, 3].includes(parseInt(sessionStorage.getItem('selectedCustomerTypeID')))) {
                return;
            } else {
                // Navigate to the appropriate store based on current context
                const currentStoreId = sessionStorage.getItem('selectedStoreId');
                if (currentStoreId === MARKETPLACESTORE) {
                    this.router.navigate(['/marketplace']);
                } else if (currentStoreId === REWARDSTORE) {
                    this.router.navigate(['/rewards']);
                } else {
                    this.router.navigate(['/shop']);
                }
                this.sideNavBarService.triggerOpen();
            }
        }

    }

    keepShopping() {
        // Get the current store ID from session storage
        const currentStoreId = sessionStorage.getItem('selectedStoreId');
        
        // Close the sidebar first
        this.sideNavBarService.triggerOpen();
        
        // Navigate to the appropriate store based on the current store ID
        if (currentStoreId === MARKETPLACESTORE) {
            // Navigate to marketplace/autoship store
            this.router.navigate(['/marketplace']);
        } else if (currentStoreId === REWARDSTORE) {
            // Navigate to rewards store
            this.router.navigate(['/rewards']);
        } else {
            // Navigate to main store (default) - use /shop instead of /shopnow
            this.router.navigate(['/shop']);
        }
    }

    checkQuantity(type, item) {
        const quantity = this.getQuantityModel(type, item)[item.ItemID];
        if (!Number(quantity)) {
            this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true);
        } else {
            if (!item.UsePoints) {
                item.Quantity = quantity;
            }
            else if (item.UsePoints) {
                item.rewardQuantity = quantity;
            }
            if (type == 'autoship') {
                localStorage.setItem('cart.autoship', JSON.stringify(this.itemsService.selectedAutoOrderItems));
                this.orderService.calculateAutoOrder();
            } else {
                localStorage.setItem((type == 'pack' ? 'cart.packs' : 'cart.order'),
                    JSON.stringify(type == 'pack' ? this.itemsService.selectedPacks : this.itemsService.selectedOrderItems));
                this.orderService.calculateOrder();
            }
        }
        this.updateQuantity(type, item, undefined);
    }

    getLastQuantity(type, item) {
        this.lastQuantity = this.getQuantityModel(type, item)[item.ItemID];
    }

    onAutoshipDateChange(event: any): void {
        if (event?.value) {
            const dateToSave = event.value.toISOString();
            localStorage.setItem('autoshipDate', dateToSave);
            this.autoshipConfigurationService.autoshipDate = event.value;
        }
    }
}
